/* This file contains the feature flag names. Feature flag is required to 
manage the incomplete feature codes segregated from the rest. */

export const CLAIM_LICENSE = "claim_license" //
export const PROFILE_DUPLICATE = "profile_duplicate" // EDCL-214
export const IG_USER_MANAGEMENT = "ig_user_management" // EDCL-181
export const RX_ZS = "rxlogger_zebrastorage" // EDCL-123
export const CONTROL_APP_UNINSTALL = "controll_app_uninstall" // EDCL-123
export const EHS = "enterprise_home_screen" // EDCL-33
export const DEVICE_USERS_CREATED_ON_FILTER = "device_users_created_on_filter" // EDCL-883
export const DEVICE_USER_LOGIN_HISTORY = "device_user_login_history" // EDCL-915
export const PENDO_TRACKING = "pendo_tracking" // EDCL-1025